import type { Params } from "../toQueryString";
import { buildPath } from "./buildPath";

export const newsletterAudienceLists = {
  list: ({
    newsletterId,
    params = {},
  }: {
    newsletterId: number;
    params?: Params;
  }) => buildPath(`/internal_api/newsletters/${newsletterId}/lists`, params),
  show: ({
    newsletterId,
    id,
    params = {},
  }: {
    id: number;
    newsletterId: number;
    params?: Params;
  }) =>
    buildPath(`/internal_api/newsletters/${newsletterId}/lists/${id}`, params),
  create: ({ newsletterId }: { newsletterId: number }) =>
    buildPath(`/internal_api/newsletters/${newsletterId}/lists`),
  update: ({ newsletterId, id }: { newsletterId: number; id: number }) =>
    buildPath(`/internal_api/newsletters/${newsletterId}/lists/${id}`),
};
